import { faker } from '@faker-js/faker';

import type { IfaApprovalPostResponse } from '../types/IfaApprovalPostResponse';

export function createIfaApprovalPostResponse(
  data: NonNullable<Partial<IfaApprovalPostResponse>> = {}
): NonNullable<IfaApprovalPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
